

exports.__esModule = true;
var _consent = require("./consent");
Object.keys(_consent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _consent[key]) return;
  exports[key] = _consent[key];
});
var _userAgreementConsent = require("./userAgreementConsent");
Object.keys(_userAgreementConsent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _userAgreementConsent[key]) return;
  exports[key] = _userAgreementConsent[key];
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/consent/index.js
// module id = ../node_modules/xo-models/src/consent/index.js
// module chunks = 0